module.exports = __webpack_public_path__ + "img/box_pro_two_5.7108e46e.jpg";